import { configureStore } from "@reduxjs/toolkit"
import appGlobalReducer from "./appGlobal"
import commonReducer from "./common"
import roleReducer from "./role"
import hrReducer from "./hr"
import bankReducer from "./bankSlice"
import countryReducer from "./countrySlice"
import cartReducer from "./cartSlice"
import menuReducer from './menuSlice' 
export default configureStore({
  reducer: {
    appGlobal: appGlobalReducer,
    role: roleReducer,
    common: commonReducer,
    hr: hrReducer,
    bank: bankReducer,
    country: countryReducer,
     cart: cartReducer,
    // calling: crmCallingReducer
    menu: menuReducer,
  },
})
